import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';
import { QuestionCircleOutlined, PlayCircleOutlined, FilePdfOutlined, FileZipOutlined, CheckCircleOutlined, QuestionOutlined } from '@ant-design/icons';
import { Menu, Dropdown, message } from 'antd';
import axios from 'axios';
import { useStateValue } from '../../providers/StateProvider';
import { catchRequest } from '../../utils';

const HelpMenu = () => {
    const history = useHistory();
    const [{ theme, lvl }] = useStateValue();
    const [{ token }, dispatch] = useStateValue();

    const verManual = () => {
        const config = { headers: { Authorization: token } };
        axios.post('/buzon/general/getManual', {}, config).then((res) => {
            // eslint-disable-next-line no-restricted-syntax
            'refreshToken' in res.data && dispatch({ type: 'ADD_TOKEN', item: { token: res.data.refreshToken } });
            if (res.data.ok) { window.open(res.data.result, '', 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes'); } else {
                message.error(res.data.message);
            }
        }).catch((e) => {
            catchRequest(e, dispatch);
        });
    };

    const menu = (
        <Menu>
            <Menu.Item onClick={() => history.push('/tutoriales')}>
                <PlayCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}

                />
                Ver videos de ayuda
            </Menu.Item>
            <Menu.Item onClick={() => verManual()}>
                <FilePdfOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Descargar el manual
            </Menu.Item>
            <Menu.Item onClick={() => window.open('https://www.winrar.es/descargas', '_blank')}>
                <FileZipOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Descargar compresor
            </Menu.Item>
            <Menu.Item onClick={() => history.push('/validacion')}>
                <CheckCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Validación de sello digital
            </Menu.Item>
            <Menu.Item onClick={() => history.push('/frecuentes')}>
                <QuestionOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Preguntas frecuentes
            </Menu.Item>

        </Menu>
    );

    const menuAuditor = (
        <Menu>
            <Menu.Item onClick={() => history.push('/validacion')}>
                <CheckCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Validación de sello digital
            </Menu.Item>

            <Menu.Item onClick={() => history.push('/tutoriales')}>
                <PlayCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Ver videos de ayuda
            </Menu.Item>
            <Menu.Item onClick={() => verManual()}>
                <FilePdfOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Descargar el manual
            </Menu.Item>
            <Menu.Item onClick={() => history.push('/frecuentes')}>
                <QuestionOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Preguntas frecuentes

            </Menu.Item>
        </Menu>
    );

    const menuAdmin = (
        <Menu>
            <Menu.Item onClick={() => history.push('/validacion')}>
                <CheckCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Validación de sello digital
            </Menu.Item>

            <Menu.Item onClick={() => history.push('/tutoriales')}>
                <PlayCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Ver videos de ayuda
            </Menu.Item>
            <Menu.Item
                onClick={() => verManual()}
            >
                <FilePdfOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Descargar el manual
            </Menu.Item>

            <Menu.Item onClick={() => history.push('/frecuentes')}>
                <QuestionCircleOutlined
                    className="mr-3"
                    style={{ color: 'dark', fontSize: 20 }}
                />
                Preguntas frecuentes

            </Menu.Item>
        </Menu>
    );

    return (
        <>
            <Dropdown overlay={lvl === '0' ? menuAuditor : lvl === '1' ? menu : menuAdmin} placement="bottomLeft" arrow>
                <QuestionCircleOutlined
                    className="mr-3"
                    style={{ color: theme === 'dark' ? '#fff' : '', fontSize: 20 }}
                />
            </Dropdown>
        </>
    );
};
export default HelpMenu;
